var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03924 18.1016C4.63225 18.1016 2.38852 17.3857 0.5 16.1504C2.10342 16.2565 4.93309 16.0024 6.69314 14.2856C4.04544 14.1614 2.85139 12.0848 2.69564 11.1974C2.92061 11.2861 3.99353 11.3926 4.59921 11.1442C1.5535 10.3632 1.08626 7.62996 1.19009 6.79578C1.76116 7.204 2.73025 7.34598 3.11096 7.31049C0.272911 5.23392 1.29392 2.11018 1.79577 1.43574C3.83246 4.3212 6.88482 5.94178 10.661 6.03192C10.5898 5.7126 10.5522 5.38014 10.5522 5.03868C10.5522 2.58813 12.4891 0.601562 14.8785 0.601562C16.1269 0.601562 17.2518 1.14388 18.0414 2.01133C18.8757 1.81143 20.1312 1.34346 20.745 0.938784C20.4356 2.07469 19.4724 3.02226 18.8898 3.37347C18.8946 3.38542 18.8851 3.36147 18.8898 3.37347C19.4016 3.29431 20.7863 3.02217 21.3333 2.64264C21.0628 3.28077 20.0417 4.34179 19.2037 4.9358C19.3596 11.9675 14.0986 18.1016 7.03924 18.1016Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOrange);
export default __webpack_public_path__ + "static/media/twitterOrange.7fba5b583acebba1dce83146a07b6b0c.svg";
export { ForwardRef as ReactComponent };